/**
 * App-level identity constants.
 *
 * The product name lives here rather than being restated at each use site:
 * it is the brand suffix on every document title, so a single declaration is
 * what keeps the browser tab, the demo shell and the static HTML in agreement.
 */

/** Product name: brand suffix on document titles. */
export const APP_NAME = 'Invyo';

/** Short product descriptor, used alongside the name in the static shells. */
export const APP_TAGLINE = 'LP Platform';

/** App version, injected from package.json at build time (see src/env.d.ts). */
export const APP_VERSION = __APP_VERSION__;
